<template>
    <div>
        <template v-if="residueSize<totalSize">
            <el-dialog
                    title="打包下载" class="fotoo"
                    :visible.sync="dialogVisible"
                    width="50%" append-to-body
                    :before-close="handleClose">
                <div class="text-center">
                    已选共计 {{MG(totalSize)}}
                    <br>当前剩余下载额度{{MG(residueSize)}}，下载额度不足请充值
                </div>
                <div class="text-center margin-tb-xl">
                    <a href="https://support.qq.com/products/57964/faqs/106896"
                       style="color: #576B95;"
                       target="_blank">如何获取免费下载额度</a>
                </div>
                <div class="flex-cm" style="padding-bottom: 40px;margin-top: 40px;" @click="dialogVisible = false">
                    <a :href="buyVipUrl" target="_blank">
                        <div class="button source" style="width: 240px;">
                            升级版本，提升下载额度
                            <div class="source-tip">下载额度100G</div>
                        </div>
                    </a>
                    <router-link :to="'/checkout/buyTraffic?activityId='+draftinfo.activityId+'&activityName='+draftinfo.activityName+'&size='+(totalSize-residueSize)+'&userId='+draftinfo.createBy">
                        <div class="button">直接充下载额度</div>
                    </router-link>
                </div>
            </el-dialog>
        </template>
    </div>
</template>
<script>
  import App from '../../util/comfun'
  import ElAlert from "../../../node_modules/element-ui/packages/alert/src/main.vue";
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";

  const M = 1024 * 1024
  const G = M * 1024
  const oneMaxSize = 99999 //G
  export default {
    components: {
      ElButton,
      ElAlert
    },
    props: {
      residueSize: {//剩余下载额度
        type: Number,
        value: 0
      },
      draftinfo: {
        type: Object,
        value: {},
      },
      totalSize: {
        type: Number,
        value: 0
      },
    },

    data() {
      return {
        oneMaxSize:oneMaxSize,
        dialogVisible: false,
        activeName: 'self',
        M: M,
        isFolder: 1,
        //自定义收集项    customInfo

        dialogVisibleDownhis: false,
        activeNameDownhis: 'wechat',
        codeurl: '',
        buyVipUrl:'',
      }
    },
    methods: {
      MG: App.MG,
      handleClick() {
      },
      handleClose(done) {
        done();
      },
      /**
       * @param res
       * params
       */
      async show() {
        if(!this.hasConfirmGo){
          if(this.residueSize<this.totalSize){
            this.dialogVisible = true
            return false
          }
          if (this.totalSize > this.oneMaxSize * G) {
            let html = `
  <div class="flex-lm" style="align-content: flex-start">
      <div style="font-size:34px;color:#FFA200; margin-left:10px;margin-right: 20px;"><i class="el-icon-warning"></i></div>
      <div style="padding-top: 20px;">
  <div style="font-size: 16px;color: #5d5d5d;">单次打包下载不能超过${this.oneMaxSize}G，请减少后重试！</div>
  <div style="font-size: 14px;color: #999999;">超过${oneMaxSize}G的文件请分批打包</div>
      </div>
  </div>
  `
            this.$alert(html, {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              confirmButtonClass: 'button-bg-green',
            });
            return false;
          }
          let hasRunning = await this.queryHasRunning()
          if (hasRunning) {
            let html = `
<div class="flex-lm" style="align-content: flex-start">
    <div style="font-size:34px;color:#FFA200; margin-left:10px;margin-right: 20px;"><i class="el-icon-warning"></i></div>
    <div style="padding-top: 20px;">
<div style="font-size: 16px;color: #5d5d5d;">已有任务正在打包中，打包开始后无法取消，并会扣除下载额度，是否继续打包？</div>
    </div>
</div>
`
            this.$confirm(html, {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定打包',
              confirmButtonClass: 'button-bg-green',
              cancelButtonText: '查看打包任务',
              cancelButtonClass: 'button-line-green',
            }).then(()=>{
              this.hasConfirmGo=true
              this.$emit('event', {type:'hasConfirmGo'})
              return this.show()
            }).catch(() => {
              this.$router.push({path: '/home/downhis'})
            });
            return false;
          }
        }
        this.hasConfirmGo=false
        return true
      },
      showTotalSize(totalSize){//剩余下载额度不足，直接显示
        this.totalSize=totalSize
        this.dialogVisible = true
      },
      
      async queryHasRunning() {
        let flag = false
        let res = await App.demand('/download/record/queryList', 'POST', {
          "activityId": this.draftinfo.activityId,
          "pageIndex": 1,
          "pageSize": 5,
          recordType: 1,
        })
        if (res.code == 200 && res.data.recordList) {
          res.data.recordList.forEach(r => {
            if (r.status == 1) {
              flag = true
              return true
            }
          })
        }
        return flag
      },
      pay() {
        this.$router.push({
          path: '/pay'
        })
      },

    },
    mounted() {
      this.buyVipUrl=App.buyVipUrl(this.draftinfo.createBy)
    },

  }
</script>

<style>
    .simple {

    }

    .tips {
        padding-left: 60px;
        height: 25px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFang, PingFang-SC;
        font-weight: SC;
        text-align: left;
        color: #999999;
        line-height: 25px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e0e0e0;
    }

    .residueSize {
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #5d5d5d;
        line-height: 30px;
        margin-top: 24px;
        margin-bottom: 24px;
    }

    .button {
        width: 200px;
        height: 60px;
        opacity: 1;
        background: #3dc4a7;
        border-radius: 30px;

        opacity: 1;
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
    }

    .source {
        margin-right: 70px;
        position: relative;
    }

    .source-tip {
        position: absolute;
        top: -15px;
        left: 152px;
        min-width: 54px;
        height: 22px;
        opacity: 1;
        background: #ed7b61;
        border-radius: 11px;
        font-size: 12px;
        color: #fefefe;
        display: flex;
        align-items: center;
        text-align: center;
        justify-items: center;
        padding-left: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        white-space: nowrap;
    }

    .source-tip::before {
        position: absolute;
        content: "";
        top: 10px;
        left: 0px;
        border-color: transparent transparent transparent #ED7B61;
        border-width: 10px;
        border-radius: 5px;
        border-style: solid;
    }

    .pfotoo.el-steps--simple {
        padding-left: 40px;
        padding-right: 40px;
    }

    .pfotoo .el-step.is-simple .el-step__head {
        display: none;
    }

    .pfotoo .el-step.is-simple:not(:last-of-type) .el-step__title {
        max-width: calc(100% - 20px);
    }

    .button-bg-green {
        width: 90px;
        height: 35px;
        background: #3dc4a7;
        border-radius: 5px;
    }

    .button-line-green {
        width: 90px;
        height: 35px;
        border: 1px solid #3dc4a7;
        border-radius: 5px;
        color: #3dc4a7;
    }
    .downall-tips-view{
        position: absolute;
        font-size: 14px;
        border-radius: 10px 10px 0 10px;
        overflow: hidden;
        width: 456px;
        height: 40px;
        top:-40px;
        left:calc(50% - 226px);
    }
    .downall-tips{
        width: 456px;
        height: 40px;
        background: #facebe;
        border-radius: 0px 28px 0px 10px;
        position: absolute;
        left:calc(50% - 226px);
        top:0px;
        content: "";
        color: #FE7157;
        font-size: 14px;
        line-height: 40px;
        text-indent: 40px;
    }
    .downall-tips::after{
        width: 42px;
        height: 38px;
        position: absolute;
        left:0;
        top:0px;
        content: "";
        color: #fefefe;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
        box-sizing: border-box;
        border-top: 40px solid #FE6E5B;
        border-right: 10px solid transparent;
    }
    .downall-tips-message{
        width: 42px;
        height: 38px;
        position: absolute;
        left:calc(50% - 226px);
        top:0px;
        content: "";
        color: #fefefe;
        font-size: 16px;
        line-height: 40px;
        text-indent: 5px;
        text-align: left;
    }
    .down-box-card .el-card__body{
        padding: 10px;
    }
    .down-box-card .el-form-item{
        margin-bottom: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/components/downResidueSize.vue